import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { UserView } from './UserView';
import { Event } from './Event';
import { FeedbackForm } from './FeedbackForm';
import { EVENTS_I_AM_ADMIN_OF } from './SecurityRules';

export interface EventFeedbackRow {
  id: number;
  submitter_user_id: string;
  event_id: number;
  feedback_form_id: number;
  content_score: number;
  delivery_score: number;
  admin_score: number;
  overall_score: number;
  additional_comments: string;
  responses: string | Record<string, string>; // written as a JSON string, read as a JSON object
  created_at: string;
}

export const EventFeedback: Entity<EventFeedbackRow> = {
  id: 'EventFeedback',
  title: 'EventFeedback',
  service: 'main',
  rowLabel: (row: EventFeedbackRow) => [row.event_id, row.submitter_user_id].join(' / '),
  rowLabelDynamic: (row: EventFeedbackRow) =>
    `<lookup:Event:${row.event_id}> / <lookup:UserView:${row.submitter_user_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.event_feedback',
  },
  security: [
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `event_id IN ${EVENTS_I_AM_ADMIN_OF}`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  listRowLink: '/admin/feedback-form/event-feedback-display/{key}',
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    submitter_user_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'User',
      mandatory: true,
      listColumn: true,
      refEntity: UserView,
    },
    event_id: {
      seq: 15,
      label: 'Event',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: Event,
    },
    feedback_form_id: {
      seq: 20,
      label: 'Feedback Form',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: FeedbackForm,
    },
    content_score: {
      seq: 25,
      type: FieldType.Integer,
      label: 'Content Score',
      listColumn: true,
    },
    delivery_score: {
      seq: 30,
      type: FieldType.Integer,
      label: 'Delivery Score',
      listColumn: true,
    },
    admin_score: {
      seq: 35,
      type: FieldType.Integer,
      label: 'Admin Score',
      listColumn: true,
    },
    overall_score: {
      seq: 40,
      type: FieldType.Integer,
      label: 'Overall Score',
      listColumn: true,
    },
    responses: {
      seq: 75,
      type: FieldType.Richtext,
      label: 'Responses',
      visible: false,
    },
    additional_comments: {
      seq: 80,
      type: FieldType.Richtext,
      label: 'Additional Comments',
      visible: false,
    },
    created_at: {
      seq: 85,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
